import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from "store/auth/authContext"
// import "./i18n"
import { Provider } from "react-redux"

import "../src/index.css"

import store from "./store"

const app = (
  <Provider store={store}>
    <AuthProvider>
    <BrowserRouter forceRefresh={true}>
      <App />
    </BrowserRouter>
    </AuthProvider>
  </Provider>
)

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()
